<script>
import bem from '@/utils/bem';
import { mapActions, mapState } from 'vuex';

const b = bem('new-collection');
export default {
  data() {
    return {
      selectedPageKey: null,
      pageKeysList: [],
      isNewPage: false,
      newPageName: '',
      selectorMode: 'saved',
      selectedCompanyId: null,
    };
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    hideModal: {
      type: Function,
      required: true,
    },
    pageKey: {
      type: String,
      required: true,
    },
    pageList: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapState({
      companies: (state) => state.companies.companies,
    }),
    companiesOptions() {
      return this.companies.map((company) => ({
        label: company.displayName,
        value: company.id,
      }));
    },
  },
  methods: {
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    ...mapActions({
      createCollectionAction: 'collections/createCollection',
      getCompaniesAction: 'companies/getCompanies',
    }),
    handleOk(values) {
      const newCollection = {
        ...values,
      };

      if (this.selectorMode === 'company') {
        const selectedCompany = this.companies.find((c) => c.id === this.selectedCompanyId);
        newCollection.companyId = this.selectedCompanyId;
        newCollection.pageKey = selectedCompany?.page_key || selectedCompany?.pageKey || '';
      } else {
        newCollection.companyId = null;
        newCollection.pageKey = this.isNewPage ? this.newPageName.replaceAll(' ', '_') : this.selectedPageKey;
      }

      this.createCollectionAction(newCollection);
      this.$emit('update:pageKey', newCollection.pageKey);
      this.hideModal();
    },
    setSelectorMode(mode) {
      this.selectorMode = mode;
      if (mode === 'saved') {
        this.isNewPage = false;
      } else if (mode === 'new') {
        this.isNewPage = true;
      }
    },
    getPageKeysList(value) {
      this.pageKeysList = value.map((item) => (
        {
          label: item.text,
          value: item.key,
        }
      ));
    },
  },
  async mounted() {
    this.selectedPageKey = this.pageKey;
    this.getPageKeysList(this.pageList);
    await this.getCompaniesAction({ limit: 1000, offset: 0 });
  },
  watch: {
    pageList: {
      handler(newValue) {
        this.getPageKeysList(newValue);
      },
      deep: true,
    },
  },
};
</script>

<template>
  <a-modal
      :open="show"
      @cancel="hideModal"
      :footer="false"
  >
    <div :class="b('')">
      <div :class="b('selector-wrap')">
        <div :class="b('selector-item')" >
          <span :class="b('select-title')">
            {{
              selectorMode === 'saved'
                ? 'Saved page keys'
                : selectorMode === 'new'
                  ? 'New page key'
                  : 'Company'
            }}
          </span>
          <div :class="b('field-title-buttons')">
            <button
                :class="b('field-title-button', { on: selectorMode === 'saved' })"
                @click="setSelectorMode('saved')"
            >
              Saved
            </button>
            /
            <button
                :class="b('field-title-button', { on: selectorMode === 'new' })"
                @click="setSelectorMode('new')"
            >
              New
            </button>
            /
            <button
                :class="b('field-title-button', { on: selectorMode === 'company' })"
                @click="setSelectorMode('company')"
            >
              Company
            </button>
          </div>
        </div>
        <a-select
            :options="pageKeysList"
            v-model:value="selectedPageKey"
            style="width: 350px"
            v-if="selectorMode === 'saved'"
        />
        <a-input
            v-model:value="newPageName"
            style="width: 350px"
            v-else-if="selectorMode === 'new'"
        />
        <a-select
            :options="companiesOptions"
            v-model:value="selectedCompanyId"
            placeholder="Select a company"
            style="width: 350px"
            v-else-if="selectorMode === 'company'"
        />
      </div>
      <FormKit
          type="form"
          submit-label="New collection"
          @submit="handleOk"
      >
        <FormKit
            type="text"
            name="name"
            label="Name"
            placeholder="Please type name"
            validation="required"
        />
        <FormKit
            type="textarea"
            name="description"
            label="Description"
            placeholder="Please type description"
            validation="required"
        />
      </FormKit>
    </div>
  </a-modal>
</template>

<style scoped lang="scss">
@import "@/styles/variables";
@import "@/styles/media";

.new-collection {
  &__selector-wrap {
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    width: 350px;
  }

  &__selector-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__select-title {
    font-weight: 600;
    margin-bottom: 5px;
  }

  &__field-title-button {
    background: none;
    border: none;
    color: rgba($light-slate-gray-color, 0.5);
    cursor: pointer;

    &_on {
      color: $tacao;
    }
  }
}
</style>
